/**
 * Return comma-separated number string with one decimal place if a float is provided.
 * @param {number} number - The number to format.
 * @param {number} precision - The number of digits to display after the decimal. Defaults to 0.
 * @returns {string} number with commas.
 */
export default function formatNumber(number, precision = 0) {
  // Bail if what we were provided is not a number.
  if (Number.isNaN(number) || ! Number.isFinite(number)) {
    return '';
  }

  return number.toLocaleString(
    'en-US',
    {
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
    }
  );
}
